import React, { useEffect, useState } from 'react'
import { List, ListItemText, ListItemIcon, ListItemButton } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import { ToolItemProps } from '../configs/toolItemsConfig'
import { ToolIcon } from './Svgs'

interface PageToolProps {
  tool: ToolItemProps | undefined
}

const PageToolComponent: React.FC<PageToolProps> = ({ tool }) => {
  const location = useLocation()
  const [selectedItem, setSelectedItem] = useState<string | null>(
    location.pathname,
  )

  const handleListItemClick = (route: string | undefined) => {
    setSelectedItem(route ? route : null)
  }

  useEffect(() => {
    setSelectedItem(location.pathname)
  }, [location])

  return (
    <List disablePadding component='nav' sx={{ width: '100%' }}>
      {!!tool && !!tool.route && (
        <ListItemButton
          component={Link}
          to={tool.route}
          selected={selectedItem === tool.route}
          onClick={() => handleListItemClick(tool.route)}
          sx={{
            borderRadius: '0.4rem',
            backgroundColor:
              selectedItem === tool.route ? '#E7E7E7' : 'inherit',
            '&.Mui-selected': {
              backgroundColor: '#E7E7E7',
            },
            '&.Mui-selected:hover': {
              backgroundColor: '#E7E7E7',
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: '0',
              mr: '1rem',
            }}
          >
            {tool.icon ? (
              <tool.icon
                color={selectedItem === tool.route ? '#1705E5' : '#97999B'}
              />
            ) : (
              <ToolIcon
                color={selectedItem === tool.route ? '#1705E5' : '#97999B'}
              />
            )}
          </ListItemIcon>
          <ListItemText
            primary={tool.label}
            primaryTypographyProps={{
              fontSize: '0.82rem',
              color: selectedItem === tool.route ? '#04002E' : '#797979',
            }}
          />
        </ListItemButton>
      )}
    </List>
  )
}

export default PageToolComponent
